import React from 'react';

const ProjectMedia = ({ media, index }) => {
  return (
    <section 
      className={`w-full py-16 ${index % 2 === 0 ? 'bg-[#fff9f3]' : 'bg-transparent'}`}
    >
      <div className="max-w-6xl mx-auto px-4 py-8">
      <div className="max-w-screen-2xl mx-auto px-4">
        {/* Video Player */}
        {media.type === 'video' && (
          <div className="overflow-hidden">
            <video 
              autoPlay
              muted
              loop
              playsInline
              className="w-full aspect-video object-cover"
            >
              <source src={media.url} type={`video/${media.format || 'mp4'}`} />
              Your browser does not support the video tag.
            </video>
          </div>
        )}

        {/* Image/GIF Display */}
        {(media.type === 'image' || media.type === 'gif') && (
          <div className="overflow-hidden">
            <img 
              src={media.url} 
              alt={media.description || 'Project visual'} 
              className="w-full h-auto object-cover"
              loading="lazy"
              decoding="async"
            />
          </div>
        )}

        {/* Optional Description */}
        {media.description && (
          <p className={`mt-6 text-lg text-center max-w-3xl mx-auto text-gray-600`}>
            {media.description}
          </p>
        )}
      </div>
      </div>
    </section>
  );
};

export default ProjectMedia;